{
  "endTime": "Končni čas",
  "startTime": "Začetni čas",
  "time": "Čas"
}
